;(function () {
	const swiperInstances = new Map()

	const initSlider = (slider, section) => {
		// Destroy existing instance if it exists
		if (swiperInstances.has(section)) {
			const existingSwiper = swiperInstances.get(section)
			if (existingSwiper && existingSwiper.destroyed === false) {
				existingSwiper.destroy(true, true)
			}
			swiperInstances.delete(section)
		}

		slider.classList.add('swiper')

		const wrapper = slider.querySelector('.popular-products__wrapper')

		if (!wrapper) return

		wrapper.classList.add('swiper-wrapper')

		const slides = slider.querySelectorAll(
			'.popular-products__item, .popular-products__item_placeholder'
		)

		if (!slides || !slides.length) return

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})

		const pagination = slider.querySelector('.popular-products-pagination')
		const slideCount = slides.length

		const updatePaginationVisibility = (swiper) => {
			if (!pagination) return
			let slidesPerView = 1.1
			if (swiper.width >= 991) slidesPerView = 3
			else if (swiper.width >= 576) slidesPerView = 2
			const shouldShowPagination = slideCount > slidesPerView
			pagination.classList.toggle('swiper-pagination-lock', !shouldShowPagination)
		}

		const swiperConfig = {
			loop: false,
			slidesPerView: 1.1,
			slidesPerGroup: 1,
			spaceBetween: 16,
			speed: 1000,
			mousewheel: {
				forceToAxis: true,
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
					slidesPerGroup: 1,
					spaceBetween: 24,
				},
				991: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 24,
				},
			},
			on: {
				init(swiper) {
					updatePaginationVisibility(swiper)
				},
				breakpoint(swiper) {
					updatePaginationVisibility(swiper)
				},
			},
		}

		if (pagination) {
			swiperConfig.pagination = {
				el: pagination,
				type: 'bullets',
				clickable: true,
				dynamicBullets: false,
				renderBullet(index, className) {
					return '<span class="' + className + '"></span>'
				},
			}
		}

		const swiperInstance = new Swiper(slider, swiperConfig)
		swiperInstances.set(section, swiperInstance)
	}

	const destroySlider = (section) => {
		if (!section || !section?.classList.contains('popular-products-section'))
			return

		const slider = section.querySelector('.popular-products-slider')
		const slides = section.querySelectorAll(
			'.popular-products__item, .popular-products__item_placeholder'
		)
		const wrapper = section.querySelector('.popular-products__wrapper')

		if (!slider || !slides || !slides.length || !wrapper) return

		// Destroy swiper instance
		if (swiperInstances.has(section)) {
			const swiperInstance = swiperInstances.get(section)
			if (swiperInstance && swiperInstance.destroyed === false) {
				swiperInstance.destroy(true, true)
			}
			swiperInstances.delete(section)
		}

		slider.classList.remove('swiper')

		slides.forEach((slide) => {
			slide.classList.remove('swiper-slide')
		})

		wrapper.classList.remove('swiper-wrapper')
	}

	const initPopularProducts = (section) => {
		if (!section || !section?.classList.contains('popular-products-section'))
			return

		const slider = section.querySelector('.popular-products-slider')
		if (!slider) return

		initSlider(slider, section)
	}

	const currentSection = document.currentScript?.parentElement
	if (currentSection) {
		destroySlider(currentSection)
		initPopularProducts(currentSection)
	}

	document.addEventListener('shopify:section:load', function (e) {
		destroySlider(e.target)
		initPopularProducts(e.target)
	})
})()
